'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class reportingModel extends ngDepModel
{

	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}


	getValue(name){
		switch(name){
			case 'payment_type_id':
				return this.getClassifValue(name, 'payment_type');
			case 'report_type_id':
				return this.getClassifValue(name, 'reporting_type');
			case 'submission_date':
			case 'paid_date':
			case 'guarantee_receipt_date':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name]);
			case 'guarantee_amount':
				if(this.guarantee_amount_on == 1 || true === this.guarantee_amount_on){
					return this.s('$filter')('currency')(this[name]);
				}
				return this.s('$filter')('tr')('value_na', 'n/a');
			case 'amount':
			case 'requested_amount':
			case 'accepted_amount':
				return this.s('$filter')('currency')(this[name]);
			case 'declared':
				if(this.report_status < 6){
					return '';
				}
				return this.s('$filter')('currency')(this[name]);
			case 'accepted':
				if(this.report_status < 12){
					return '';
				}
				return this.s('$filter')('currency')(this[name]);
			case 't1_no':
				return this.s('$filter')('tr')('t1_no_tpl', 'Initial pre-financing No {no}').replace(/\{no\}/, this.no) + ((this.no > 1) ? ' *' : '');
			case 't1_no_clean':
				return this.s('$filter')('tr')('t1_no_tpl', 'Initial pre-financing No {no}').replace(/\{no\}/, this.no);
			case 'deadline_text':
				if(this.payment_type_id == 1){
					return this.s('$filter')('tr')((this.no > 1) ? 'deadline_60_days' : 'deadline_30_days');
				}
				if(this.payment_type_id == 9){
					return this.s('$filter')('tr')('deadline_90_days_final');
				}
				return this.s('$filter')('tr')('deadline_90_days');
			case 'period':
				return this.month_from + ' - ' + this.month_to;
			case 'payment_status':
				return this.getClassifValue(name, 'payment_status');
			case 'payment_deadline':
				if(this[name] == 0){
					return '';
				}
				if(this.payment_type_id == 1){
					return this.s('$filter')('u2date')(this[name]);
				}
				if(this.payment_deadline > 0 && this.payment_deadline_pause_on < 1){
					return this.s('$filter')('u2date')(this[name]);
				}
				if(this.payment_deadline_pause_on > 0){
					return this.s('$filter')('tr')('payment_deadline_paused');
				}
				return '';
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}

	afterSetup(data){
		this.makeCetField('submission_date', true);
		this.submission_date_cet.setHours(12);
		this.makeCetField('guarantee_receipt_date', true);
		this.guarantee_receipt_date_cet.setHours(12);
	}

}
